import { useQuery, useQueryClient } from '@tanstack/react-query'

export function useLocalData<T>(queryKey: string[], enabled = false) {
  const { data } = useQuery(queryKey, {
    enabled,
  })
  return data as T
}

export const setLocalData = <T>(key: string[]) => {
  const queryClient = useQueryClient()
  const setData = (data: T) => {
    queryClient.setQueryData<T>(key, data)
  }

  return setData
}

export const useStoreData = (key: string) => {
  const queryClient = useQueryClient()
  return function setData(newData: { [key: string]: any }) {
    queryClient.setQueryData([key], (oldData: { [key: string]: any }) => {
      return {
        ...oldData,
        ...newData,
      }
    })
  }
}
